import type { Step } from 'react-joyride';

export const MEMBRESIAS_HOME_TOUR_ID = 'membresias-home';

type MembresiasHomeTourFlags = {
  hasModuleSwitcher: boolean;
};

export function buildMembresiasHomeTourSteps({
  hasModuleSwitcher,
}: MembresiasHomeTourFlags): Step[] {
  const steps: Step[] = [];

  if (hasModuleSwitcher) {
    steps.push({
      target: '[data-tour="module-switcher"]',
      title: 'Cambia de módulo',
      content: 'Desde aquí puedes moverte entre Tesorería, Membresías y Logística.',
      placement: 'right',
      skipBeacon: true,
    });
  }

  steps.push(
    {
      target: '[data-tour="membresias-home-priorities"]',
      title: 'Qué necesita tu atención',
      content:
        'Un vistazo rápido a miembros activos, cuentas por cobrar pendientes, cargos eventuales y si ya tienes un turno de caja abierto.',
      placement: 'bottom',
      skipBeacon: !hasModuleSwitcher,
    },
    {
      target: '[data-tour="membresias-home-priority-caja"]',
      title: 'Turno de caja',
      content: 'Antes de cobrar un recibo, confirma aquí si ya tienes un turno de caja abierto.',
      placement: 'top',
    },
    {
      target: '[data-tour="membresias-home-tool-recibos"]',
      title: 'Recibos de caja',
      content: 'Aquí registras cobros por cuotas y cargos, y administras el turno de caja.',
      placement: 'top',
    },
    {
      target: '[data-tour="membresias-home-tool-reportes"]',
      title: 'Reportes',
      content: 'Analiza la antigüedad de la cartera y la proyección de cobro esperado.',
      placement: 'top',
    },
    {
      target: '[data-tour="help-button"]',
      title: '¿Necesitas repasar esto?',
      content: 'Puedes volver a ver esta guía cuando quieras desde este botón.',
      placement: 'left',
    },
  );

  return steps;
}
